import React, { useEffect, useState } from "react";
import DefaultModal from "../DefaultModal.jsx";
import LoaderContainer from "../../mui/loader_container/LoaderContainer.jsx";
import { API_USER } from "../../../api/user.js";
import { TEST_MODE } from "../../../store/enums.js";
import { testDetailBalance } from "../../../store/testConst.js";
import useBalance from "../../../hooks/useBalance.js";
import { useAppSelector } from "../../../store/index.ts";
import "./detail-balance.scss";
import DetailBalanceContent from "./content/DetailBalanceContent.jsx";
import { ENUM_COMMON_EVENT } from "../../../hooks/common/useListener.js";
import { dispatchCusEvent } from "../../../utils/utils.js";

export default function DetailBalance({ isOpen, closeModal }) {
  const { mainBalance, bonusBalance } = useBalance();
  const currency = useAppSelector((state) => state.user.currency);
  const [loader, setLoader] = useState(true);
  const [balance, setBalance] = useState({});

  const balanceString = mainBalance?.toLocaleString();
  const bonusBalanceString = bonusBalance?.toLocaleString();
  const openForPayout = balance.openForPayout?.toLocaleString();

  const detailDepositBalance = balance.depositBalance;
  const detailBonusBalance = balance.bonusBalance;

  useEffect(() => {
    setLoader(true);
    setBalance({});

    if (!isOpen) return;
    if (TEST_MODE) {
      setBalance(testDetailBalance);
      setLoader(false);
      return;
    }

    dispatchCusEvent(ENUM_COMMON_EVENT.getBalance);

    API_USER.balance
      .detail({ currency })
      .then((e) => {
        const data = e.data;
        setBalance(data);
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, [isOpen, currency]);

  return (
    <DefaultModal isOpen={isOpen} closeModal={closeModal} classModal="detail-balance-modal">
      <LoaderContainer loader={loader} center>
        <DetailBalanceContent
          currency={currency}
          mainBalance={balanceString}
          openMain={openForPayout}
          bonusBalance={bonusBalanceString}
          detailBonusBalance={detailBonusBalance}
          detailDepositBalance={detailDepositBalance}
        />
      </LoaderContainer>
    </DefaultModal>
  );
}
